import {
  RudiApplicantDetails,
  CommonApplicantDetails,
  SEApplicantDetails,
  AdditionalDocCommonApplicantDetails,
} from "./applicantDetailsTypes";
import { RudiEducationDetails } from "./educationTypes";
import { DocumentDetails } from "./documentTypes";
import { BaseNomenclature, DocumentReceiveMethod, ReceiverAddress } from "@duosoftbg/nacid-components";

export interface CommonApplication {
  dataStateStatus: string;
  id?: number;
  documentDetails: DocumentDetails;
  applicantDetails: CommonApplicantDetails;

  entryNumber?: string;
  entryDate?: string;
  submittedOrFinalized?: boolean;
}

export interface RudiApplication extends CommonApplication {
  applicantDetails: RudiApplicantDetails;
  educationDetails: RudiEducationDetails;
}

export interface SEApplication extends CommonApplication {
  applicantDetails: SEApplicantDetails;
}

export interface AdditionalDocCommonApplication extends CommonApplication {
  applicantDetails: AdditionalDocCommonApplicantDetails;
}

export enum FoApplicationStatus {
  DRAFT = "DRAFT",
  FINALIZED = "FINALIZED",
  SUBMITTED = "SUBMITTED",
  SUBMITTED_WITH_SIGNATURE = "SUBMITTED_WITH_SIGNATURE",
  ACCEPTED = "ACCEPTED",
  FOR_CORRECTION = "FOR_CORRECTION",
}

export interface ApplicationDocumentReceiveMethod {
  resultReceive: DocumentReceiveMethod;
  receiverAddress: ReceiverAddress;
}

export interface ApplicationDocumentReceiveOption {
  resultReceive: DocumentReceiveMethod;
  receiverAddress: ReceiverAddress;
  optionKind: BaseNomenclature;
}
